export enum ActorType {
	CURSOR = 'cursor',
	ON_CHILD_ATTRIBUTE_UPDATE = 'onChildAttributeUpdate',
	ON_KEYDOWN = 'onKeydown',
	ON_KEYPRESS = 'onKeypress',
	ON_KEYUP = 'onKeyup',
	ON_PLAYER_EVENT = 'onPlayerEvent',
	ON_SCENE_RESET = 'onSceneReset',
	ON_SCENE_PLAY_STATE = 'onScenePlayState',
	ON_TICK = 'onTick',
	ON_OBJECT_ATTRIBUTE_UPDATE = 'onObjectAttributeUpdate',
	ON_OBJECT_CLICK = 'onObjectClick',
	ON_OBJECT_DISPATCH_EVENT = 'onObjectDispatchEvent',
	ON_OBJECT_HOVER = 'onObjectHover',
	ON_OBJECT_POINTERDOWN = 'onObjectPointerdown',
	ON_OBJECT_POINTERUP = 'onObjectPointerup',
	ON_POINTERDOWN = 'onPointerdown',
	ON_POINTERUP = 'onPointerup',
	ON_VIDEO_EVENT = 'onVideoEvent',
	ON_WEBXR_CONTROLLER_EVENT = 'onWebXRControllerEvent',
	RAY_FROM_CURSOR = 'rayFromCursor',
	RAY_FROM_CAMERA = 'rayFromCamera',
	// SET_OBJECT_HOVERED_STATE = 'setObjectHoveredState',
}
